import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SolicitationService } from 'src/app/pages/privado/services/usuario/solicitation.service';
@Component({
  selector: 'app-modal-alterar-dados-usuario',
  templateUrl: './modal-alterar-dados-usuario.component.html',
  styleUrls: ['./modal-alterar-dados-usuario.component.css']
})
export class ModalAlterarDadosUsuarioComponent {
  @Input() formUserData: any;
  @Input() beneficiaryCpf: any;
  faSquareXmark = faSquareXmark;
  listaDocumentos: any;
  changeUserData: any;
  formGroup: FormGroup = new FormGroup({
    files: new FormControl(null, Validators.required),
    acceptedterms: new FormControl(false, [Validators.required])
  });
  constructor(public activeModal: NgbActiveModal, private solicitationService: SolicitationService, private toast: ToastrService) { }
  onSubmit() {
    this.changeUserData = {
      ...this.formUserData,
      ...this.formGroup.getRawValue(),
      beneficiaryCpf: this.beneficiaryCpf,
      dataGroupRequest: 1
    }
    this.solicitationService.changeUserData(this.changeUserData).subscribe({
      next: (response: any) => {
        this.activeModal.close('success');
        this.toast.success('Dados alterados com sucesso!');
      },
      error: (err) => {
        this.activeModal.close('error');
        this.toast.error(err.message);
      }
    });
  }
  adicionarArquivos(event: any) {
    this.formGroup.get('files')?.setValue(event);
    this.formGroup.get(`files`)?.updateValueAndValidity();
  }
  removeFile(fileType: string, index: number) {
    const lista: any = this.formGroup.get(`files.file`)?.value;
    lista.splice(index, 1);
    this.formGroup.get(`files.file`)?.updateValueAndValidity();
  }
}
